import React, { useEffect, useState } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';
import logoImg from '../assets/logo.png';
import PageLoading from './PageLoading';

const Container = styled.div`
  padding: 30px 10%;
  font-size: 14px;
`;
const Logo = styled.img`
  margin-bottom: 20px;
  width: 30px;
  height: 30px;
`;

const MarkdownPage = ({ url }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios(url)
      .then(({ data }) => {
        setData(data);
      })
      .catch((error) => console.error(error));
  }, [url]);

  if (data) {
    return (
      <Container>
        <Logo src={logoImg} alt="logo" />
        <ReactMarkdown source={data} />
      </Container>
    );
  }
  return <PageLoading />;
};

MarkdownPage.propTypes = {
  url: PropTypes.string.isRequired,
};

export default MarkdownPage;
